const PREFIX = "gifting-multi-delivery-info-widget";
export const GIFTING_MULTI_DELIVERY_INFO_DATA_TEST_IDS = {
    CONTAINER: `${PREFIX}-container`,
    TEXT: `${PREFIX}-text`,
    CTA: `${PREFIX}-cta`,
};
